import { CommonModule, NgFor, NgForOf, NgIf } from '@angular/common';
import { AfterViewInit, Component, computed, effect, ElementRef, Renderer2, Signal } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { TextControlService } from 'src/app/services/text-control.service';

@Component({
  selector: 'tx-ribbon-clipboard-overlay',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './ribbon-clipboard-overlay.component.html',
  styleUrl: './ribbon-clipboard-overlay.component.scss',
})
export class RibbonClipboardOverlayComponent implements AfterViewInit {
  widthPercentage: Signal<number> = computed(() => {
    const newWidth = 100 - this.textControlService.clipboardDataTransferProgressPercentage();
    return newWidth;
  });
  currentlySyncing: boolean = false;
  overlayElement: ElementRef | undefined;
  parentOverlayElement: ElementRef | undefined;
  constructor(private renderer: Renderer2, private el: ElementRef, private textControlService: TextControlService) {
    effect(() => {
      const currentWidth = 100 - this.textControlService.clipboardDataTransferProgressPercentage();
      if (this.textControlService.clipboardDataTransferInProgress() != this.currentlySyncing) {
        false === this.currentlySyncing ? this.restart() : this.endSyncing();
      } else {
        if (this.currentlySyncing) {
          this.updateWidth(currentWidth);
        }
      }
      this.currentlySyncing = this.textControlService.clipboardDataTransferInProgress();
    });
    this.animate();
  }
  animate() {}
  ngAfterViewInit() {
    const watchForElement = setInterval(() => {
      const ribbonGroupContent = this.el.nativeElement
        .closest('tx-edit-document')

        ?.querySelector('.ribbon-group-content');
      if (
        ribbonGroupContent &&
        this.overlayElement === undefined &&
        ribbonGroupContent.getBoundingClientRect().width > 0
      ) {
        this.createOverlay();
        clearInterval(watchForElement);
      }
    }, 250);
  }

  createOverlay() {
    if (this.overlayElement != undefined && this.parentOverlayElement != undefined) {
      return;
    }
    const ribbonGroupContent = this.el.nativeElement
      .closest('tx-edit-document')
      ?.querySelector('.ribbon-group-content');

    if (ribbonGroupContent) {
      let overlayParent = ribbonGroupContent.querySelector('#clipboard-overlay-parent');
      if (!overlayParent) {
        overlayParent = this.renderer.createElement('div');
        this.renderer.setAttribute(overlayParent, 'id', 'clipboard-overlay-parent');
        this.renderer.appendChild(ribbonGroupContent, overlayParent);
      }
      let overlay = ribbonGroupContent.querySelector('#clipboard-overlay');
      if (!overlay) {
        overlay = this.renderer.createElement('div');
        this.renderer.setAttribute(overlay, 'id', 'clipboard-overlay');
        this.renderer.setStyle(overlayParent, 'display', 'none');
        this.renderer.appendChild(overlayParent, overlay);
      }
      let overlayText = ribbonGroupContent.querySelector('#clipboard-overlay-text');
      if (!overlayText) {
        overlayText = this.renderer.createElement('span');
        this.renderer.setAttribute(overlayText, 'id', 'clipboard-overlay-text');
        this.renderer.appendChild(overlayText, this.renderer.createText('Syncing...'));
        this.renderer.appendChild(overlayParent, overlayText);
      }
      this.renderer.setStyle(ribbonGroupContent, 'position', 'relative');

      this.renderer.setStyle(overlay, 'width', `0%`);
      this.renderer.setStyle(overlay, 'border-radius', `10px`);
      this.overlayElement = overlay;
      this.parentOverlayElement = overlayParent;
      return;
    }
    return;
  }
  restart() {
    this.renderer.setStyle(this.parentOverlayElement, 'display', 'block');
    this.renderer.setStyle(this.overlayElement, 'right', 'auto');
    this.renderer.setStyle(this.overlayElement, 'left', '0');
    this.renderer.setStyle(this.overlayElement, 'width', `100%`);
    this.renderer.setStyle(this.parentOverlayElement, 'opacity', '1');
    this.renderer.setStyle(this.parentOverlayElement, 'width', '100%');
  }
  endSyncing() {
    this.renderer.setStyle(this.parentOverlayElement, 'opacity', '0');
    this.renderer.setStyle(this.parentOverlayElement, 'width', '0%');
    setTimeout(() => {
      this.renderer.setStyle(this.parentOverlayElement, 'display', 'none');
    }, 100);
  }
  animateLatest() {
    this.updateWidth(this.widthPercentage());
  }
  updateWidth(newWidth: number) {
    this.renderer.setStyle(this.overlayElement, 'right', '0');
    this.renderer.setStyle(this.overlayElement, 'left', 'auto');
    this.renderer.setStyle(this.overlayElement, 'width', `${newWidth}%`);
  }
}
